import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { resolveFichaReturnPath } from '../../app/helpers/moduleFichaNavHelper';
import FlowStateSemaphore from './components/FlowStateSemaphore';
import FlowRecordHistoryModal from './components/FlowRecordHistoryModal';
import { FLOW_MODULE_DEFINITIONS } from '../../app/helpers/flowEngineConfigHelper';
import {
  resolveBandejaTitle,
  hasRecordMotivo,
  resolveRecordMotivo,
  resolveStateName
} from '../../app/helpers/flowHistoryDisplayHelper';
import { getSemaphoreTitle, resolveFlowStateSemaphore } from '../../app/helpers/flowStateSemaphoreHelper';

const FlowEngineBandejaBanner = ({ record, moduleProcess = 'technology' }) => {
  const { t } = useTranslation();
  const flowEngine = useSelector((state) => state.flowEngine);
  const roleLogin = useSelector((state) => state.userRole?.roleLogin);
  const roles = roleLogin?.roles || [];
  const selectedRole = roleLogin?.roleSpecialistSelected || null;
  const [historyOpen, setHistoryOpen] = useState(false);

  if (!record?.id) {
    return null;
  }

  const moduleId = FLOW_MODULE_DEFINITIONS[moduleProcess]?.moduleId;
  const bandejaTitle = resolveBandejaTitle(record, roles, t, selectedRole, flowEngine);
  const stateName = resolveStateName(record.state_catalog_id, flowEngine);
  const motivo = resolveRecordMotivo(record, flowEngine, t);
  const showMotivo = hasRecordMotivo(record, flowEngine);
  const semaphore = resolveFlowStateSemaphore(record.state_catalog_id, flowEngine.states);

  return (
    <>
      <div className="card border-0 shadow-sm mb-3 mx-2 mx-md-4">
        <div className="card-body py-3 px-3 px-md-4">
          <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
            <div className="d-flex flex-wrap align-items-start gap-4">
              <div>
                <div className="small text-muted">
                  <Link to={resolveFichaReturnPath(moduleProcess)} className="text-muted text-decoration-none">
                    {bandejaTitle}
                  </Link>
                </div>
                <strong>{t('flow.record.case-number', 'Número de caso')}: {record.id}</strong>
              </div>
              <div>
                <div className="small text-muted">{t('general.flow-engine.current-state', 'Estado actual')}</div>
                <strong>{stateName || getSemaphoreTitle(semaphore, t)}</strong>
              </div>
              {showMotivo && (
                <div className="flex-grow-1" style={{ minWidth: '220px' }}>
                  <div className="small text-muted">{t('flow.motivo.label', 'Motivo')}</div>
                  <span>{motivo}</span>
                </div>
              )}
            </div>
            <div className="ms-auto">
              <FlowStateSemaphore
                stateCatalogId={record.state_catalog_id}
                size="lg"
                onClick={() => setHistoryOpen(true)}
              />
            </div>
          </div>
        </div>
      </div>

      {moduleId && (
        <FlowRecordHistoryModal
          show={historyOpen}
          onHide={() => setHistoryOpen(false)}
          record={record}
          moduleId={moduleId}
          moduleProcess={moduleProcess}
          selectedRole={selectedRole}
        />
      )}
    </>
  );
};

FlowEngineBandejaBanner.propTypes = {
  record: PropTypes.object,
  moduleProcess: PropTypes.string
};

export default FlowEngineBandejaBanner;
